;(function($, undefined){
    var rnn, log,
        jqRegisterModal = $('#register-modal'),
        txtRegisterModalCookieName = 'registerModalIsLoaded',
        registerModalIsEnabled = (jqRegisterModal.length) ? true : false;

    function displayRegisterModal(){
        //Add the cookie and initially set the value to FALSE
        if (Cookies.get(txtRegisterModalCookieName) === undefined) {
            Cookies.set(txtRegisterModalCookieName, 'false', { expires: 365, path: '/' });
        }

        var registerModalIsLoaded = (Cookies.get(txtRegisterModalCookieName) === 'true') ? true : false,
            hasCookie = (Cookies.get(txtRegisterModalCookieName) !== undefined) ? true : false;

        rnn.modules.user.get(function(user){
            if(!user.authenticated) //Is not logged in
            {
                if(hasCookie && !registerModalIsLoaded)
                {
                    jqRegisterModal.modal('show');
                    Cookies.set(txtRegisterModalCookieName, 'true', { expires: 365, path: '/' });
                }
            }
            else //Logged in
            {
                if(hasCookie && !registerModalIsLoaded)
                    Cookies.set(txtRegisterModalCookieName, 'true', { expires: 365, path: '/' });
            }
        });
    }

    function initRegisterModal(){
        if(registerModalIsEnabled)
            displayRegisterModal();
    }

    rnn = window.rnn;
    log = rnn.logging.log;

    rnn.modules.register('registerModal', {
        init: initRegisterModal
    });

})(jQuery);